import $ from 'jquery';
import { keyCodes } from '../../../../../@infinite/scripts/core/INF-keyCodes';
import initRteAccordions from './initRteAccordions';
import themeEditor from './themeEditor'; 

export default function() {
  initRteAccordions();
  themeEditor();

  $(document).on('click keyup', '[data-tab-toggle]', (e) => {
    if (e.keyCode) {
      if (e.keyCode !== keyCodes.enter && e.keyCode !== keyCodes.space) { return; }
    }

    const $toggle = $(e.currentTarget);
    const $tabHeading = $toggle.parent('.tab-heading');
    const $content = $tabHeading.siblings('.tab-content');
    const $container = $tabHeading.parent();
    $content.toggleClass('tab-content--open');
    $toggle.toggleClass('TabToggle--opened');
    $container.attr('aria-expanded', false);
    $content.attr('style', '');
    $content.attr('aria-hidden', true).attr('data-prevent-tab', true);
    if ($content.hasClass('tab-content--open')) {
      const height = $tabHeading.find('[data-tab-height-calc]').outerHeight();
      $content.attr('aria-hidden', false).removeAttr('data-prevent-tab');
      $container.attr('aria-expanded', true);
      $content.css({
        maxHeight: height,
      });

      if ($content.data('background')) {
        $content.css({
          background: $content.data('background'),
        });
      }
    }
  });
}